import React, { useContext, useEffect } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';

import { DashboardCard } from '../../Components/Dashboard';
import { NewContext } from '../../Context/NewContext';
import { get_dashboard_data } from '../../Controller/actions';

import './dashboard.css';

export const Dashboard = ({ title }) => {
    const { currentTableData, setCurrentTableData, isLoading, setIsLoading } = useContext(NewContext);

    const getDashboardData = async (_currentPage = 1) => {
        setIsLoading(true);
        try {
            const getDashboards = await get_dashboard_data();
            if (getDashboards) {
                const { status, data } = getDashboards;
                if (status) {
                    setCurrentTableData(data);
                } else {
                    setCurrentTableData([]);
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getDashboardData();
    }, []);

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`
    }, [])

    return (
        <div className='dashboard-main ms-auto p-3'>
            <div className='dashboard-header mb-3 d-flex justify-content-between'>
                <h3>Dashboard</h3>
            </div>
            <Row className=''>
                {
                    isLoading ?
                        <div className="d-flex justify-content-center align-items-center">
                            <Spinner animation="border" />
                        </div>
                        : currentTableData?.length < 1 ?
                            <div className="d-flex justify-content-center align-items-center">
                                No Data Found
                            </div>
                            : currentTableData?.map((_dash, i) => (
                                <Col sm={6} md={6} lg={4} xl={4} xxl={3} key={i}>
                                    <DashboardCard variant={"light"} cardData={_dash} />
                                </Col>
                            ))
                }
            </Row>
        </div>
    )
};

Dashboard.defaultProps = {
    title: "Dashboard"
};

export default Dashboard;
